import { IMemberDepricated, IValueLabel } from "@mctypes/global.types";
import React, { useEffect, useState } from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { useAppSelector } from "../../../../hooks";

import { usePutProjectMemberMutation } from "../../../../../openapi";
import { MEMBER_GROUPS } from "../../../globalConstants";

const ProjectGroupSelector: React.FC<{ group: IValueLabel; memberId: string }> = ({ group, memberId }) => {
  const [member, setMember] = useState<IMemberDepricated>();
  const [memberIsMulticonsult, setMemberIsMulticonsult] = useState<boolean>();

  useEffect(() => {
    const _member = project.members.find((mbr) => mbr._id === memberId);

    if (_member != null) {
      const _memberIsMulticonsult = _member.user.email && _member.user.email.toLowerCase().endsWith("@multiconsult.no");
      setMemberIsMulticonsult(_memberIsMulticonsult);
    }
    setMember(_member);
  }, []);

  const project = useAppSelector((state) => state.adminReducer.project);

  const [updateMemberAttribute, { isError }] = usePutProjectMemberMutation();

  const getItemsInMemberGroup = () => {
    if (memberIsMulticonsult && member.group === "INTERNAL") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value === "ADMIN" || group.value === "INTERNAL";
      });
    }

    if (memberIsMulticonsult && member.group === "ADMIN") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value === "ADMIN" || group.value === "INTERNAL";
      });
    }

    if (memberIsMulticonsult === false && member.group !== "INTERNAL") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value !== "INTERNAL";
      });
    }
    return MEMBER_GROUPS;
  };

  return (
    <UncontrolledDropdown>
      {member != null && memberIsMulticonsult != null && (
        <>
          <DropdownToggle className="w-100 d-flex align-items-center justify-content-between" caret outline>
            {group == null ? "Ikke satt" : group}
          </DropdownToggle>
          <DropdownMenu container="body">
            {getItemsInMemberGroup().map((group, index) => (
              <DropdownItem
                key={index}
                onClick={() =>
                  updateMemberAttribute({
                    body: {
                      projectId: project._id,
                      attribute: "group",
                      value: group.value,
                      memberId: memberId,
                    },
                  })
                }
              >
                {group.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </>
      )}
    </UncontrolledDropdown>
  );
};

export default ProjectGroupSelector;
